import { gql } from '@apollo/client';

export const SET_PREFERRED_LOCALE_MUTATION = gql`
  mutation SetPreferredLocale($locale: Locale!) {
    setPreferredLocale(locale: $locale)
  }
`;
